import { Component, OnInit, ViewChild } from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { select, Store } from '@ngrx/store';
import clone from 'just-clone';
import { combineLatest, Observable, of, ReplaySubject } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import * as fromCumsActions from '../../contract-cumulative/store/contract-cumulative.actions';
import * as fromCumsReducer from '../../contract-cumulative/store/contract-cumulative.reducer';
import * as fromDataServices from '../../data-services';
import * as fromEIActions from '../../expense-item/store/expense-item.actions';
import { ExpenseItem } from '../../expense-item/store/expense-item.model';
import * as fromEIReducer from '../../expense-item/store/expense-item.reducer';
import * as fromLookups from '../../lookups';
import { IDirectReport, LoadServiceItems } from '../../lookups';
import { PayrollItem } from '../../payroll/item/store';
import * as fromCommon from '../../shared';
import * as fromShared from '../../shared';
import { SelectItem, uniqBy } from '../../shared';
import { LoggingService } from '../../shared/services/logging';
import * as fromUser from '../../user-info';
import { IUserInfo } from '../../user-info';
import {
    Item,
    ManualAdjustmentPresenterComponent
} from '../manual-adjustment-presenter/manual-adjustment-presenter.component';
@Component({
    selector: 'ef-manual-adjustment-feature',
    templateUrl: './manual-adjustment-feature.component.html',
    styleUrls: ['./manual-adjustment-feature.component.scss'],
    standalone: false
})
export class ManualAdjustmentFeatureComponent implements OnInit {
    process$: Observable<fromShared.Process>;
    @ViewChild(ManualAdjustmentPresenterComponent, { static: true })
    presenter: ManualAdjustmentPresenterComponent;

    public adjustments$: Observable<
        fromDataServices.ManualAdjustment.ManualAdjustment[]
    >;
    public serviceitems$: Observable<fromLookups.IServiceItem[]>;
    public directreports$: Observable<IDirectReport[]>;
    public tasks$: Observable<fromLookups.ITask[]>;
    public userGroups$: Observable<fromLookups.IUserGroup[]>;
    public contracts$: Observable<fromDataServices.Contract.Contract[]>;
    public txntypes$: Observable<fromLookups.CalcType[]>;
    public payrollitems$: Observable<PayrollItem[]>;
    public userInfo$: Observable<IUserInfo>;
    public expenseitems$: Observable<ExpenseItem[]>;
    public companysettings$: Observable<
        fromDataServices.RecalculateSettings.RecalculateSetting[]
    >;
    public items$: Observable<Item[]>;
    public userInfo: IUserInfo;
    public contractsSelectItem$: Observable<SelectItem[]>;

    selectedError$: Observable<fromShared.Errors.IShowErrors>;
    selectedErrorWithStatus$: Observable<fromCommon.IStatusMessage>;
    ShowError = new ReplaySubject<fromShared.Errors.IShowErrors>(1);

    active = true;
    IsLoading: boolean;
    adjustmentsDataService: EntityCollectionService<fromDataServices.ManualAdjustment.ManualAdjustment>;
    contractDataService: EntityCollectionService<fromDataServices.Contract.Contract>;
    recalculateSettingsDataService: EntityCollectionService<fromDataServices.RecalculateSettings.RecalculateSetting>;
    CSFYStart: string;
    CSFYEnd: string;

    constructor(
        public entityServices: EntityServices,
        private log: LoggingService,
        private store: Store
    ) {
        this.adjustmentsDataService =
            entityServices.getEntityCollectionService<fromDataServices.ManualAdjustment.ManualAdjustment>(
                fromDataServices.ManualAdjustment.entityName
            );
        this.contractDataService =
            entityServices.getEntityCollectionService<fromDataServices.Contract.Contract>(
                fromDataServices.Contract.entityName
            );
        this.recalculateSettingsDataService =
            entityServices.getEntityCollectionService<fromDataServices.RecalculateSettings.RecalculateSetting>(
                fromDataServices.RecalculateSettings.entityName
            );
    }

    ngOnInit() {
        this.contractDataService.getAll();
        this.recalculateSettingsDataService.getWithQuery({
            SettingType: 'FYStartDate'
        });
        // this.recalculateSettingsDataService.getWithQuery({ SettingType: 'FYEndDate' });
        this.store.dispatch(fromEIActions.getExpenseItems());
        // this.store.dispatch(fromStore.getPayrollItems());
        this.store.dispatch(fromCumsActions.getTxnTypes());
        this.store.dispatch(new fromLookups.LoadUserGroups());
        this.store.dispatch(new fromLookups.LoadTasks());
        this.store.dispatch(new LoadServiceItems(false, true, true));
        this.setupObservables();
        this.setupSubscriptions();
        // var initialPOSTData: any = {
        //     DirectOrIndirect: 'Direct',
        //     Todayonly: false,
        //     Asofdate: `${moment(this.userInfo.CurrentPayPeriodStart).format('MM/DD/YYYY')} - ${moment(this.userInfo.CurrentPayPeriodEnd).format('MM/DD/YYYY')}`,
        //     Tasks: null,
        //     ServiceItems: null,
        //     DirectReports: null,
        //     CostCenters: null,
        //     Txntype: null
        // };
        // this.adjustmentsDataService.getWithQuery(initialPOSTData);
    }

    ngOnDestroy() {
        this.active = false;
    }

    setupObservables() {
        this.companysettings$ =
            this.recalculateSettingsDataService.entities$.pipe(
                map(x => clone(x))
            );

        this.userInfo$ = this.store.pipe(select(fromUser.getUserInfo));

        this.process$ = this.store.pipe(select(fromShared.selectCurrent));

        this.expenseitems$ = this.store.pipe(
            select(fromEIReducer.selectAll),
            map(x => clone(x))
        );

        this.adjustments$ = this.adjustmentsDataService.entities$.pipe(
            map(c => clone(c))
        );

        this.userGroups$ = this.store.pipe(
            select(fromLookups.getUserGroupsLookup)
        );

        this.payrollitems$ = this.store.pipe(
            select(fromLookups.getPayrollItemsLookup),
            map(x => clone(x) as PayrollItem[]),
            map(payrollItems =>
                payrollItems
                    // .filter(x => x.IsActive !== false)
                    .sort((a, b) => a.PayrollItem.localeCompare(b.PayrollItem))
            ),
            map(items => uniqBy(items, x => x.PIListID) as PayrollItem[])
        );

        this.directreports$ = this.store.pipe(
            select(fromLookups.getDirectReportsLookup),
            map(x => clone(x)),
            //map(users => users.filter(x => x.IsActive == true)),
            map(x =>
                x.sort((a, b) => a.EmployeeName.localeCompare(b.EmployeeName))
            )
        );

        this.serviceitems$ = this.store.pipe(
            select(fromLookups.getServiceItemsLookup),
            map(x => clone(x)),
            map(x =>
                x.sort((a, b) => a.ServiceItem.localeCompare(b.ServiceItem))
            )
        );

        this.tasks$ = this.store.pipe(
            select(fromLookups.getTasksLookup),
            map(x => clone(x)),
            map(x =>
                x.sort((a, b) => a.TaskLongName.localeCompare(b.TaskLongName))
            )
        );

        this.txntypes$ = this.store.pipe(
            select(fromCumsReducer.selectTxnTypes),
            map(x => clone(x)),
            map(x => x.sort((a, b) => a.CalcDesc.localeCompare(b.CalcDesc)))
        );

        this.contracts$ = this.contractDataService.entities$.pipe(
            map(x => clone(x)),
            map(x =>
                x.sort((a, b) => a.ContractDesc.localeCompare(b.ContractDesc))
            )
        );

        this.contractsSelectItem$ = this.contracts$.pipe(
            map(contracts =>
                contracts.filter(x => x.IsActive == true && x.ContractType != 'LOC').map(contract => ({
                    label: contract.ContractDesc,
                    value: contract.ContractListID
                }))
            ),
            map(contracts =>
                contracts.sort((a, b) => a.label.localeCompare(b.label))
            )
        );
    }

    setupSubscriptions() {
        combineLatest([this.process$, this.ShowError])
            .pipe(takeWhile(() => this.active))
            .subscribe(([process, event]) => {
                this.store.dispatch(
                    new fromShared.Errors.SetShowErrors({
                        open: event.open,
                        MsgEntityID: event.MsgEntityID,
                        MsgProcessID: process.ProcessID
                    })
                );
            });
        this.adjustments$
            .pipe(takeWhile(() => this.active))
            .subscribe(() => (this.IsLoading = false));

        this.userInfo$
            .pipe(takeWhile(() => this.active))
            .subscribe(userInfo => {
                this.userInfo = userInfo;
                this.store.dispatch(new fromLookups.LoadDirectReports({user: userInfo, activeOnly: false}));
            });
        this.directreports$.pipe(takeWhile(() => this.active)).subscribe(dr => {
            this.store.dispatch(
                new fromLookups.LoadPayrollItems([
                    ...(dr.map(z => z.EmployeeListID) || [])
                ])
            );
        });
        combineLatest([this.serviceitems$, this.expenseitems$])
            .pipe(takeWhile(() => this.active))
            .subscribe(([si, ei]) => {
                let siarr: any[] = si;
                siarr = siarr.map(x => ({
                    IListID: x.SIListID,
                    Item: x.ServiceItem,
                    IsActive: x.IsActive
                }));
                let eiarr: any[] = ei;
                eiarr = eiarr.map(x => ({
                    IListID: x.EIListID,
                    Item: x.ExpenseItem,
                    IsActive: x.IsActive
                }));
                const items: Item[] = siarr.concat(eiarr);
                this.items$ = of(items);
            });
    }

    onLoadAdjustments($event) {
        this.log.verbose({
            type: 'ManualAdjustmentFeatureComponent:onLoadAdjustments',
            $event
        });
        this.adjustmentsDataService.clearCache();
        if ($event != null) {
            this.adjustmentsDataService.getWithQuery($event);
        } else {
            this.adjustmentsDataService.getWithQuery(null);
        }
    }

    onAddAdjustments($event) {
        this.log.verbose({
            type: 'ManualAdjustmentFeatureComponent:onAddAdjustments'
        });
        // this.adjustmentsDataService.clearCache();
        if ($event != null) {
            this.adjustmentsDataService.getWithQuery($event);
        } else {
            this.adjustmentsDataService.getWithQuery(null);
        }
    }

    onSaveAdjustment($event) {
        this.log.verbose({
            type: 'ManualAdjustmentFeatureComponent:onSaveAdjustment'
        });
        this.adjustmentsDataService.update($event);
    }

    onDeleteAdjustment($event) {
        this.adjustmentsDataService.delete($event);
    }
}
